module.exports = __webpack_public_path__ + "static/img/credit-wuhu-4.aa306978.jpg";